import { JoinGroupPayload } from "@grassrootly/api/gateways";
import server from "../Server";
import withErrorCheck from "../CheckError";
import { IGroupPlayers } from "@grassrootly/api/entities";
import moment from "moment";

export const JoinGroup = async (payload: JoinGroupPayload): Promise<IGroupPlayers | null> => {
  const groupsResponse = await server.from("Groups").select("*").eq("join_code", payload.join_code);

  const groups = withErrorCheck(groupsResponse);

  if (!groups || groups.length === 0) {
    throw new Error("Group with this join code does not exist.");
  }

  const group = groups[0];

  const groupMemberResponse = await server
    .from("GroupPlayers")
    .select("*")
    .eq("player_id", payload.playerId)
    .eq("group_id", group.id);

  let groupMember = withErrorCheck(groupMemberResponse)?.[0] || null;

  if (groupMember) {
    throw new Error("You are already a member of this group.");
  }

  const insertGroupMemberResponse = await server
    .from("GroupPlayers")
    .insert({
      player_id: payload.playerId,
      group_id: group.id,
      is_owner: false,
      created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
    })
    .select();

  groupMember = withErrorCheck(insertGroupMemberResponse)?.[0] || null;

  if (!groupMember) {
    throw new Error("Failed to add player to the group");
  }

  return {
    id: groupMember.id,
    created_at: groupMember.created_at,
    group_id: group.id,
    player_id: payload.playerId,
    is_owner: !!groupMember.is_owner,
  };
};
